export default __webpack_public_path__ + "static/media/alphie-welcome.b141b6d6.gif";